import { useEffect } from 'react'
import { useGetMember } from '@/common/hooks/useGetMember'
import { useHasGivenConsent } from '@/common/hooks/useHasGivenConsent'
import { trackLoginState } from '@/content/services/gtm/utils/trackLoginState'

/**
 * Component that tracks the login state when the app initializes
 * Fires a GTM event once per session to track whether user is logged in
 * Must be rendered within OccContext to have access to member data
 */
export const LoginStateTracker = () => {
    const member = useGetMember()
    const hasConsent = useHasGivenConsent()

    useEffect(() => {
        if (hasConsent === undefined) return
        if (member.isSignedIn && member.id === undefined) return
        trackLoginState(member.isSignedIn, member.id)
    }, [member.id, member.isSignedIn, hasConsent])

    return null
}
